<div>
  <div class="modal-header pb-0">
    <h2 class="modal-title" i18n="@@newlogin.security.information.title">About Sell Connect Login Page</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <ul class="list-group">
      <li class="list-group-item list-group-item-action flex-column align-items-start">
        <div class="w-100">
          <strong i18n="@@newlogin.security.information.version">App Version</strong>
          <p class="row justify-content-end">{{ version() }}</p>
        </div>
      </li>
      <li class="list-group-item list-group-item-action flex-column align-items-start">
        <div class="w-100">
          <strong i18n="@@newlogin.security.information.sessionId">Session ID</strong>
          <p class="row justify-content-end">{{ token }}</p>
        </div>
      </li>
    </ul>
    <div class="d-grip">
      @if (token) {
      <button
        type="button"
        class="btn btn-primary w-100"
        (click)="clipboardToken()"
        aria-label="Copy"
        i18n-aria-label="@@newlogin.security.information.button.copyAria"
      >
        @if (showIcon) {
        <span class="icon-check" aria-hidden="true"></span>
        }
        <ng-container i18n="@@newlogin.security.information.button.copy">{{ label }}</ng-container>
      </button>
      }
    </div>
  </div>
</div>
